import FormItem from './FormItem.vue'
export default FormItem


// WEBPACK FOOTER //
// ./src/components/FormItem/index.js